import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { environmentSelectors } from 'store/slices/environment/selectors';
import PageLoader from 'components/PageLoader/PageLoader';
import { getEnvironment } from 'store/slices/environment/api';
import { setEnvironment } from 'store/slices/environment/reducer';

interface Props {
  children: React.ReactNode;
}

export const ProviderEnvironment = ({ children }: Props) => {
  const dispatch = useDispatch();
  const environment = useSelector(environmentSelectors.environment);

  useEffect(() => {
    getEnvironment().then((fetchedEnvironment) => {
      dispatch(setEnvironment(fetchedEnvironment));
    });
  }, []);

  if (!Object.keys(environment).length) {
    return <PageLoader />;
  }

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>;
};
